module.exports = __webpack_public_path__ + "static/media/22_shape_l.23bd135a.webp";